import { render, staticRenderFns } from "./CustomerLoyaltyDashboard.vue?vue&type=template&id=e6bb2a30&scoped=true"
import script from "./CustomerLoyaltyDashboard.vue?vue&type=script&lang=js"
export * from "./CustomerLoyaltyDashboard.vue?vue&type=script&lang=js"
import style0 from "./CustomerLoyaltyDashboard.vue?vue&type=style&index=0&id=e6bb2a30&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6bb2a30",
  null
  
)

export default component.exports